import { ObjectValues } from 'type-alias';

export const USER_LOGIN_PROVIDER = {
  Essensys: 'Essensys',
  LinkedIn: 'LinkedIn',
  ParkWhiz: 'ParkWhiz',
  Microsoft: 'Microsoft',
  ProxyClick: 'ProxyClick',
  Safetrust: 'Safetrust',
  AzureAD: 'MicrosoftAzure',
  Google: 'GoogleWorkplace',
  Okta: 'Okta',
  Apple: 'Apple',
  Auth0: 'Auth0',
  NotDefined: 'NotDefined',
} as const;

export type USER_LOGIN_PROVIDER_VALUES = ObjectValues<
  typeof USER_LOGIN_PROVIDER
>;
